import { useCallback, useRef } from "react";

// Highchart
import Highcharts from "highcharts";

// Constants
import { REFERENCE_LABEL_STYLES } from "../chart.constants";

// Types
import { IChartAxisTitle } from "components/Charts/chart.types";
import { LD1Chart, LD4Chart, LD6Chart } from "store/slice/charts/chartsSlice.types";

export type IRenderWatermarks = (chart: Highcharts.Chart, isExporting?: boolean) => void;
export interface IUseRenderWatermarkLabels {
    renderWatermarkLabels: IRenderWatermarks;
}

const useRenderWatermarkLabels = (chartData: LD1Chart | LD4Chart | LD6Chart): IUseRenderWatermarkLabels => {
    const chartWatermarks = useRef<IChartAxisTitle[]>([]);

    const renderWatermarkLabels = useCallback(
        (chart: Highcharts.Chart, isExporting?: boolean) => {
            const { current: watermarks } = chartWatermarks;

            if (watermarks.length === 0) {
                chartData.watermarks.forEach(({ label, x, y }) => {
                    watermarks.push({
                        key: label,
                        svg: chart.renderer.label(label, x, y).css(REFERENCE_LABEL_STYLES).add(),
                    });
                });
            }

            if (isExporting) {
                watermarks.forEach((watermark) => {
                    const {
                        svg: { textStr, x, y },
                    } = watermark;
                    watermark.svg = chart.renderer.label(textStr, x, y).css(REFERENCE_LABEL_STYLES).add();
                });
            }

            watermarks.forEach((element: IChartAxisTitle, i: number) => {
                const { plotTop, plotLeft, plotWidth, plotHeight } = chart;
                const labelBBox = element.svg.getBBox();

                if (element.key === "Expert") {
                    element.svg.attr({ x: 0, y: plotTop + labelBBox.height });
                }
                if (element.key === "Star") {
                    element.svg.attr({ x: plotWidth + plotLeft - labelBBox.width, y: plotTop + labelBBox.height });
                }
                if (element.key === "Nascent") {
                    element.svg.attr({ x: 0, y: plotHeight + plotTop - labelBBox.height });
                }
                if (element.key === "Challenger") {
                    element.svg.attr({
                        x: plotWidth + plotLeft - labelBBox.width,
                        y: plotHeight + plotTop - labelBBox.height,
                    });
                }
            });
        },
        [chartData]
    );

    return { renderWatermarkLabels };
};

export default useRenderWatermarkLabels;
